export default __webpack_public_path__ + "locales/pt-BR/PeopleTranslations.json?hash=ec7845a38d3b5a435e322128a4cd0461";